export default {
  reports: {
    // Milestone and hierarchy filters (R-33/R-34, §90)
    filtersTitle: "Filters (optional)",
    filtersClear: "Clear filters",
    channelAll: "Both channels",
    channelPharmacy: "Pharmacy channel",
    channelHospital: "Hospital channel",
    hier_atc: "ATC code",
    hier_ah: "Homogeneous group",
    hier_spr: "Reference-price set",
    hier_pa: "Active ingredient",
    hier_nregistro: "Registration no.",
    hier_cn: "National code",
    hierPlaceholder_atc: "e.g. C09CA (any depth)",
    hierPlaceholder_ah: "group code or name",
    hierPlaceholder_spr: "e.g. F206",
    hierPlaceholder_pa: "e.g. Olmesartan",
    hierPlaceholder_nregistro: "e.g. 75012",
    hierPlaceholder_cn: "e.g. 770428",
    opTitle: "Initial Operation Report",
    opIntro: "Runs per source, events detected and alerts sent, availability in the period and incidents with their response and resolution times.",
    opShort: "The period has {n} days: the operation report covers at least thirty calendar days.",
    opFrom: "From",
    opGoLive: "Go-live: {date}. The default period is the thirty days from that date.",
    opNoGoLive: "No go-live date recorded (it is set on the organisation's record).",
    opTo: "To",
    opGenerate: "Generate PDF",
    title: "Reports",
    newTemplate: "+ New template",
    intro: "Report templates for your organization: assemble custom blocks, save the configuration and generate the PDF whenever you need it.",
    noTemplates: "No templates yet",
    noTemplatesWrite: "Create your first template by combining the available blocks (KPIs, events, radar, CIPM…).",
    noTemplatesRead: "An administrator or analyst in your organization can create report templates.",
    createTemplate: "Create template",
    generating: "Generating…",
    generate: "Generate",
    generateNow: "Generate now",
    edit: "Edit",
    delete: "Delete",
    lastReport: "Last report: {date}",
    neverGenerated: "Never generated",
    deleteTitle: "Delete template?",
    deleteMessage: "\"{name}\" will be deleted. This action cannot be undone.",
    templateDeleted: "Template deleted",
    templateSaved: "Template saved",
    periodMonth: "Current month",
    periodLastMonth: "Last month",
    periodLastQuarter: "Last quarter",
    periodCustom: "Custom",
    scopePortfolioAndCompetitors: "Portfolio and competitors",
    scopePortfolio: "My portfolio only",
    scopeCompetitors: "Competitors only",
    scopeMarket: "Full market",
    scopeProduct: "Specific products",
    editTemplate: "Edit template",
    newReportTemplate: "New report template",
    templateName: "Template name",
    optionalToGenerate: "(optional to generate)",
    templateNamePlaceholder: "e.g. Monthly management cycle",
    pdfLanguage: "PDF language",
    spanish: "Spanish",
    english: "English",
    period: "Period",
    from: "From",
    to: "To",
    scope: "Scope",
    noProducts: "No products in your portfolio.",
    reportSections: "Report sections",
    addAtLeastOne: "Add at least one section.",
    moveUp: "Move up",
    moveDown: "Move down",
    removeSection: "Remove section",
    addSection: "Add section",
    availableInUltra: "Available on the ULTRA plan",
    cancel: "Cancel",
    preview: "Preview",
    downloadPdf: "Download PDF",
    saving: "Saving…",
    saveChanges: "Save changes",
    saveTemplate: "Save template",
  },
};
